import { IdentifierDTO } from '@zazume/zzm-base';

import { LeadActivity } from '#/models/LeadActivity';

import { doDelete, doGet, doPost, doPut } from '../../helpers';

export interface CreateLeadActivityInputs {
  title: string;
  type: string;
  scheduledAt: Date;
  timezone: string;
  duration: number;
  notes?: string;
  leadId: IdentifierDTO;
}

export interface UpdateLeadActivityInputs {
  title?: string;
  type?: string;
  scheduledAt?: Date;
  timezone?: string;
  duration?: number;
  notes?: string;
}

export const leadActivities = {
  getByLead: (leadId: IdentifierDTO) => () => doGet<LeadActivity[]>(`/dashboard/lead-activities?leadId=${leadId}`),
  get: (leadActivityId: IdentifierDTO) => () => doGet<LeadActivity>(`/dashboard/lead-activities/${leadActivityId}`),
  create:
    () =>
    (body: CreateLeadActivityInputs): Promise<LeadActivity> =>
      doPost('/dashboard/lead-activities', body),
  update:
    (leadActivityId: IdentifierDTO) =>
    (body: UpdateLeadActivityInputs): Promise<LeadActivity> =>
      doPut(`/dashboard/lead-activities/${leadActivityId}`, body),
  markAsDone:
    (leadActivityId: IdentifierDTO) =>
    (body: { done: boolean }): Promise<LeadActivity> =>
      doPut(`/dashboard/lead-activities/${leadActivityId}/done`, body),
  delete: (leadActivityId: IdentifierDTO): Promise<void> => doDelete(`/dashboard/lead-activities/${leadActivityId}`)
};
